import type { MessengerFeatureConfig } from '../type';

export const messenger: Partial<MessengerFeatureConfig> = {
    totalAttachmentsSizeLimitInMBs: 15,
    extendedAllowedAttachmentExtensions: ['rtf', 'ppt', 'pptx'],
};
